// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { bool, func, string } from 'prop-types'

const Trigger = ({ id, menuIsOpen, toggleMenu }) => (
  <p
    className={'pointer'}
    id={id}
    onClick={toggleMenu}>
    <i className={`fa fa-fw fa-2x fa-${menuIsOpen ? 'times' : 'bars'}`} />
  </p>
)

Trigger.propTypes = {
  id: string.isRequired,
  menuIsOpen: bool.isRequired,
  toggleMenu: func.isRequired,
}

export default Trigger
